$(document).on("turbolinks:load", function(){
    booking_destroy_choose();
    
})

function booking_destroy_choose(){
    $("#new_adult_booking_destroy_choose_form").validationEngine({
        promptPosition: "topLeft"
    });

}